import * as types from '../actions/actionTypes';
import {
  assign,
  cloneDeep,
  concat,
  each,
  filter,
  keyBy,
  sumBy,
  groupBy,
  findIndex,
  map
} from 'lodash';
import moment from 'moment';

const initialState = {
  facilitiesMasterList: [],
  garageProfileDetails: {},
  companyImages: [],
  openJobsList: {
    waitingJobs: [],
    appliedJobs: [],
    inProgressJobs: [],
    confirmedJobs: [],
    completedJobs: [],
  },
  jobList: {},
  nextPageInOpenJobs: 0,
  pageInfo: {
    waitingJobsTotalCount: 0,
    appliedJobsTotalCount: 0,
    inProgressJobsTotalCount: 0,
    confirmedJobsTotalCount: 0,
    expiredJobsTotalCount: 0,
    closedJobsTotalCount: 0,
    completedJobsTotalCount: 0,
    declinedJobsTotalCount: 0,
    jobHistoryTotalCount: 0
  },
  isSliderLoaded: false,
  jobHistory: [],
  jobHistoryList: {
    allJobHistory: [],
    completedJobs: [],
    declinedJobs: [],
    expiredJobs: [],
    closedJobs: []
  },
  openJobsFilters: {
    "confirmed": {
      'filter': '',
      'sort': ''
    },
    "applied": {
      'filter': '',
      'sort': ''
    },
    "waiting": {
      'filter': '',
      'sort': ''
    },
    "inprogress": {
      'filter': '',
      'sort': ''
    },
    "completed": {
      'filter': '',
      'sort': ''
    },
    "jobhistory": {
      'filter': '',
      'sort': ''
    }
  }
};

export default function jobRequestReducer(state = initialState, action) {
  console.log('What Action ', action.type);
  switch (action.type) {
    case types.GET_OPEN_JOB_CATEGORIES:
      {
        const newState = {
          currentComponentKey: '',
          nextPageInOpenJobs: action.openJobCategoryList && action.currentPage + (action.openJobCategoryList.length),
          pageInfo: state.pageInfo
        };
        if (action.unableToFetch) {
          if (action.jobStatusId == 1) {
            newState['waitingJobsLoaded'] = true;
          } else if (action.jobStatusId == 2) {
            newState['appliedJobsLoaded'] = true;
          } else if (action.jobStatusId == 3) {
            newState['inProgressJobsLoaded'] = true;
          } else if (action.jobStatusId == 4) {
            newState['confirmedJobsLoaded'] = true;
          }else if (action.jobStatusId == 7) {
            newState['completedJobsLoaded'] = true;
          }
        } else {
          let openJobsList = {};
          let a = cloneDeep(action.openJobCategoryList);
          console.log('What is a',a);
          if (action.jobStatusId == 2) {
            let b = cloneDeep(state.openJobsList.waitingJobs);
            openJobsList = {
              ...state.openJobsList,
              waitingJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              waitingJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['waitingJobsLoaded'] = true;
          } else if (action.jobStatusId == 1) {
            let b = cloneDeep(state.openJobsList.appliedJobs);
            openJobsList = {
              ...state.openJobsList,
              appliedJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              appliedJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['appliedJobsLoaded'] = true;
          } else if (action.jobStatusId == 3) {
            let b = cloneDeep(state.openJobsList.inProgressJobs);
            openJobsList = {
              ...state.openJobsList,
              inProgressJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              inProgressJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['inProgressJobsLoaded'] = true;
          } else if (action.jobStatusId == 4) {
            let b = cloneDeep(state.openJobsList.confirmedJobs);
            openJobsList = {
              ...state.openJobsList,
              confirmedJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              confirmedJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['confirmedJobsLoaded'] = true;
          } else if (action.jobStatusId == 7) {

            let b = cloneDeep(state.openJobsList.completedJobs);
            openJobsList = {
              ...state.openJobsList,
              completedJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              completedJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['completedJobsLoaded'] = true;


            console.log('openJobList ',action.openJobCategoryList);
            console.log('openJobList ',openJobsList );
          }

          newState['openJobsList'] = openJobsList;
        }
        return assign({}, state, newState);
      }

    case types.GET_POSTED_JOB_BY_ID:
      {
        console.log(' Posted ');
        if (action.unableToFetch) {
          return assign({}, state, {
            isSliderLoaded: true,
            unableToFetchPostedJobById: true
          });
        } else {
          const openJobsStatusMap = ['appliedJobs', 'waitingJobs', 'inProgressJobs', 'confirmedJobs'];
          let jobList = cloneDeep(state.jobList);
          // let jobHistoryList = cloneDeep(state.jobHistoryList);
          let jobStatusType = '';
          if (action.jobDetails.garagejobquote && action.jobDetails.garagejobquote.jobdetailstatus && action.jobDetails.garagejobquote.jobdetailstatus.name) {
            jobStatusType = action.jobDetails.garagejobquote.jobdetailstatus.name.toLowerCase();
          } else {
            jobStatusType =action && action.jobStatus ? action.jobStatus.toLowerCase() : (action.jobDetails.requeststatus && action.jobDetails.requeststatus.name) ? action.jobDetails.requeststatus.name.toLowerCase() : '';
          }
          console.log("jobStatusType = ", jobStatusType);
          let createdAt, quotesSent, jobPrefferedDate, jobPrefferedTime, jobStartDate, jobStartTime, jobEndDate, jobEndTime, userPrefferedDatetime = '';
          let totalamount = 0;
          const quotesList = [];
          if (action.jobDetails && action.jobDetails.createdAt) {
            createdAt = moment(action.jobDetails.createdAt).format('MMMM D, YYYY, hh:mm A');
          }
          let photos = undefined;
          if (action.jobDetails.images && action.jobDetails.images.length > 0) {
            photos = filter(action.jobDetails.images, (image) => {
              return image.type == 'image';
            });
          }
          let quotesGrouped = undefined;
          if (action.jobDetails && action.jobDetails.userbookingrequest_services && action.jobDetails.userbookingrequest_services.length) {
            quotesGrouped = groupBy(action.jobDetails.userbookingrequest_services, 'parent.name');
          }
          let jobDetails = action.jobDetails;
          console.log('#### jobDetails ',jobDetails);
          jobDetails = assign({}, jobDetails, {
            'requestid': action.jobDetails.requestid || '-',
            'userbookingrequestId': action.jobDetails.id,
            'jobStatus': jobStatusType,
            'customer': action.jobDetails.users && action.jobDetails.users.name ? action.jobDetails.users.name : '-',
            'customerId': action.jobDetails.userId ? action.jobDetails.userId : '',
            'createdAt': createdAt,
            'jobDetails': action.jobDetails.details || '-',
            'details': (jobDetails.userbookingrequest_services && jobDetails.userbookingrequest_services.length) ? (jobDetails.userbookingrequest_services.length > 1 ? (jobDetails.userbookingrequest_services[0].name + ', +' + (jobDetails.userbookingrequest_services.length - 1) + ' more') : jobDetails.userbookingrequest_services[0].name) : '-',
            'photos': photos || [],
            'carProfileAvailable': action.jobDetails && action.jobDetails.vehicles ? true : false,
            'carProfile': action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.name ? action.jobDetails.vehicles.make ? action.jobDetails.vehicles.name + '-' + action.jobDetails.vehicles.make : action.jobDetails.vehicles.name : '-',
            'plateNo': action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.plateNo ? action.jobDetails.vehicles.plateNo : '-',
            'carmake': action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.carmake ? action.jobDetails.vehicles.carmake : '-',
            'carmodel': action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.carmodel ? action.jobDetails.vehicles.carmodel : '-',
            'year': action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.year ? action.jobDetails.vehicles.year : '-',
            'insuraceProvider': (action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.insuranceprovider) ? action.jobDetails.vehicles.insuranceprovider : '-',
            'policyNo': (action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.insurancepolicynumber) ? action.jobDetails.vehicles.insurancepolicynumber : '-',
            'chassisNumber': (action.jobDetails && action.jobDetails.vehicles && action.jobDetails.vehicles.chassisNumber) ? action.jobDetails.vehicles.chassisNumber : '',
            'serviceType': (action.jobDetails.services && action.jobDetails.services.name) ? action.jobDetails.services.name : '-',
            'quotesList': quotesList,
            'quotesGrouped': quotesGrouped,
            'userbookingrequest_services': action.jobDetails.userbookingrequest_services,
            'currency': 'AED',
            'quotesLoaded': true
          });
          if (jobStatusType.toLowerCase() == 'waiting') {
            if (action.jobDetails && action.jobDetails.userPrefferedDatetime) {
              userPrefferedDatetime = moment(action.jobDetails.userPrefferedDatetime);
              jobPrefferedDate = moment(userPrefferedDatetime).format('MMMM D, YYYY');
              jobPrefferedTime = moment(userPrefferedDatetime).format('hh:mm A');
            }
            if (action.jobDetails && action.jobDetails.userbookingrequest_services && action.jobDetails.userbookingrequest_services.length > 0) {
              each(action.jobDetails.userbookingrequest_services, (userbookingrequest_service) => {
                quotesList.push({
                  'name': userbookingrequest_service.name,
                  'serviceId': userbookingrequest_service.serviceId,
                  'currency': 'AED'
                });
              });
            }
            jobDetails['jobPrefferedDate'] = jobPrefferedDate || '-';
            jobDetails['jobPrefferedTime'] = jobPrefferedTime || '-';
            jobDetails['userPrefferedDatetime'] = userPrefferedDatetime || '-';
            jobDetails['quotesReceived'] = action.jobDetails && action.jobDetails.quotesreceived || '0';
          } else {
            let serviceIds = undefined;
            const garagejobquote = action.jobDetails && action.jobDetails.garagejobquote ? action.jobDetails.garagejobquote : undefined;
            if (garagejobquote) {
              serviceIds = keyBy(garagejobquote.garagejobquotesdetail, 'serviceId');
            }
            const garageJobQuotesByKey = (action.jobDetails && action.jobDetails.garagejobquote && action.jobDetails.garagejobquote.garagejobquotesdetail && action.jobDetails.garagejobquote.garagejobquotesdetail.length) ? keyBy(action.jobDetails.garagejobquote.garagejobquotesdetail, 'serviceId') : undefined;
            if (action.jobDetails && action.jobDetails.userbookingrequest_services && action.jobDetails.userbookingrequest_services.length > 0) {
              each(action.jobDetails && action.jobDetails.userbookingrequest_services, (userbookingrequest_service) => {
                if (serviceIds && serviceIds[userbookingrequest_service.serviceId] && serviceIds[userbookingrequest_service.serviceId].amount) {
                  totalamount += serviceIds[userbookingrequest_service.serviceId].amount;
                }
                quotesList.push({
                  'name': userbookingrequest_service.name,
                  'serviceId': userbookingrequest_service.serviceId,
                  'amount': (serviceIds[userbookingrequest_service.serviceId] && serviceIds[userbookingrequest_service.serviceId]) ? serviceIds[userbookingrequest_service.serviceId].amount : '',
                  'currency': (serviceIds[userbookingrequest_service.serviceId]) ? serviceIds[userbookingrequest_service.serviceId].currency : '',
                  'jobdetailstatusId': (garageJobQuotesByKey && garageJobQuotesByKey[userbookingrequest_service.serviceId] && garageJobQuotesByKey[userbookingrequest_service.serviceId].jobdetailstatusId) ? garageJobQuotesByKey[userbookingrequest_service.serviceId].jobdetailstatusId : 0
                });
              });
            }
            if (garagejobquote && garagejobquote.createdAt) {
              quotesSent = moment(garagejobquote.createdAt).format('MMMM D, YYYY, hh:mm A');
            }
            if (garagejobquote && garagejobquote.jobStartDatetime) {
              jobStartDate = moment(garagejobquote.jobStartDatetime).format('MMMM D, YYYY');
              jobStartTime = moment(garagejobquote.jobStartDatetime).format('hh:mm A');
              jobDetails['jobStartDate'] = jobStartDate || '-';
              jobDetails['jobStartTime'] = jobStartTime || '-';
              jobDetails['jobStartDatetime'] = moment(garagejobquote.jobStartDatetime);
            }
            if (garagejobquote && garagejobquote.jobEndDatetime) {
              jobEndDate = moment(garagejobquote.jobEndDatetime).format('MMMM D, YYYY');
              jobEndTime = moment(garagejobquote.jobEndDatetime).format('hh:mm A');
              jobDetails['jobEndDate'] = jobEndDate || '-';
              jobDetails['jobEndTime'] = jobEndTime || '-';
              jobDetails['jobEndDatetime'] = moment(garagejobquote.jobEndDatetime);
            }
            jobDetails['quotesSent'] = quotesSent || '-';
            jobDetails['totalamount'] = totalamount;
          }
          switch (jobStatusType.toLowerCase()) {
            case 'waiting':
              {
                jobDetails['jobStatusDisplayName'] = 'Waiting';
                break;
              }
            case 'applied':
              {
                jobDetails['jobStatusDisplayName'] = 'Applied';
                jobDetails['quotesReceived'] = action.jobDetails.quotesreceived || '0';
                break;
              }
            case 'confirmed':
              {
                jobDetails['jobStatusDisplayName'] = 'Confirmed';
                break;
              }
            case 'inprogress':
              {
                jobDetails['jobStatusDisplayName'] = 'In Progress';
                break;
              }
            case 'decline':
              {
                jobDetails['jobStatusDisplayName'] = 'Declined';
                break;
              }
            case 'completed':
              {
                jobDetails['jobStatusDisplayName'] = 'Completed';
                break;
              }
            case 'expired':
              {
                jobDetails['jobStatusDisplayName'] = 'Expired';
                break;
              }
            case 'closed':
            {
              jobDetails['jobStatusDisplayName'] = 'Closed';
              break;
            }
            default:
              {
                break;
              }
          }
          const openJobsList = cloneDeep(state.openJobsList);
          const jobHistoryList = cloneDeep(state.jobHistoryList);
          const pageInfo = cloneDeep(state.pageInfo);
          if (action.replaceWaitingWithApplied) {
            const jobIndex = findIndex(openJobsList['waitingJobs'], function (job) {
              return job.userbookingrequestId == jobDetails.userbookingrequestId;
            });
            if (jobIndex > -1) {
              openJobsList['waitingJobs'].splice(jobIndex, 1);
              openJobsList['appliedJobs'].unshift(jobDetails);
              pageInfo.appliedJobsTotalCount = pageInfo.appliedJobsTotalCount + 1;
              pageInfo.waitingJobsTotalCount = pageInfo.waitingJobsTotalCount - 1;
            }
          } else {
            switch (jobStatusType.toLowerCase()) {
              case 'waiting':
                {
                  const jobIndex = findIndex(openJobsList['waitingJobs'], function (job) {
                    return job.userbookingrequestId == jobDetails.userbookingrequestId;
                  });
                  if (action.fromNotification && action.notificationType === 'New Request') {
                    openJobsList['waitingJobs'].unshift(jobDetails);
                    pageInfo.waitingJobsTotalCount = pageInfo.waitingJobsTotalCount + 1;
                  } else if (jobIndex > -1) {
                    if (openJobsList['waitingJobs'][jobIndex] && openJobsList['waitingJobs'][jobIndex].vehicles) {
                      jobDetails.vehicles = { ...openJobsList['waitingJobs'][jobIndex].vehicles };
                    }
                    openJobsList['waitingJobs'][jobIndex] = jobDetails;
                  }
                  break;
                }
              case 'applied':
                {
                  const jobIndex = findIndex(openJobsList['appliedJobs'], function (job) {
                    return job.userbookingrequestId == jobDetails.userbookingrequestId;
                  });
                  if (action.fromNotification && action.notificationType === 'Applied Job') {
                    // const waitingJobIndex = findIndex(openJobsList['waitingJobs'], function (job) {
                    //   return job.userbookingrequestId == jobDetails.userbookingrequestId;
                    // });
                    // if (waitingJobIndex > -1) {
                    //   openJobsList['waitingJobs'].splice(waitingJobIndex, 1);
                    // }
                    openJobsList['appliedJobs'].unshift(jobDetails);
                    pageInfo.appliedJobsTotalCount = pageInfo.appliedJobsTotalCount + 1;
                  }

                  if (jobIndex > -1) {
                    if (openJobsList['appliedJobs'][jobIndex] && openJobsList['appliedJobs'][jobIndex].userbookingrequest && openJobsList['appliedJobs'][jobIndex].userbookingrequest.vehicles) {
                      jobDetails.vehicles = { ...openJobsList['appliedJobs'][jobIndex].userbookingrequest.vehicles };
                    }
                    openJobsList['appliedJobs'][jobIndex] = jobDetails;
                  }
                  break;
                }
              case 'confirmed':
                {
                  if (action.fromNotification && action.notificationType === 'Job Accepted') {
                    const appliedJobIndex = findIndex(openJobsList['appliedJobs'], function (job) {
                      return job.userbookingrequestId == jobDetails.userbookingrequestId;
                    });
                    if (appliedJobIndex > -1) {
                      openJobsList['appliedJobs'].splice(appliedJobIndex, 1);
                      pageInfo.appliedJobsTotalCount = (pageInfo.appliedJobsTotalCount > 0) ? pageInfo.appliedJobsTotalCount - 1 : 0;
                    }
                    openJobsList['confirmedJobs'].unshift(jobDetails);
                    pageInfo.confirmedJobsTotalCount = pageInfo.confirmedJobsTotalCount + 1;
                  }
                  const jobIndex = findIndex(openJobsList['confirmedJobs'], function (job) {
                    return job.userbookingrequestId == jobDetails.userbookingrequestId;
                  });
                  if (jobIndex > -1) {
                    if (openJobsList['confirmedJobs'][jobIndex] && openJobsList['confirmedJobs'][jobIndex].userbookingrequest && openJobsList['confirmedJobs'][jobIndex].userbookingrequest.vehicles) {
                      jobDetails.vehicles = { ...openJobsList['confirmedJobs'][jobIndex].userbookingrequest.vehicles };
                    }
                    openJobsList['confirmedJobs'][jobIndex] = jobDetails;
                  }
                  break;
                }
              case 'inprogress':
                {
                  const jobIndex = findIndex(openJobsList['waitingJobs'], function (job) {
                    return job.userbookingrequestId == jobDetails.userbookingrequestId;
                  });
                  if (jobIndex > -1) {
                    if (openJobsList['inProgressJobs'][jobIndex] && openJobsList['inProgressJobs'][jobIndex].userbookingrequest && openJobsList['inProgressJobs'][jobIndex].userbookingrequest.vehicles) {
                      jobDetails.vehicles = { ...openJobsList['inProgressJobs'][jobIndex].userbookingrequest.vehicles };
                    }
                    openJobsList['inProgressJobs'][jobIndex] = jobDetails;
                  }
                  break;
                }
              case 'decline':
              case 'cancelled':
              case 'completed':
              case 'closed': {
                if (
                  action.fromNotification &&
                  (action.notificationType === 'Request Cancel' || action.notificationType === 'Confirmed Job Decline') &&
                  action.notification && action.notification.previousStatusId) {
                  console.log("openJobsList = ", openJobsList[openJobsStatusMap[action.notification.previousStatusId]]);
                  const jobIndex = findIndex(openJobsList[openJobsStatusMap[(action.notification.previousStatusId - 1)]], function (job) {
                    console.log("userbookingrequestId = ", job.userbookingrequestId, jobDetails.userbookingrequestId);
                    return job.userbookingrequestId == jobDetails.userbookingrequestId;
                  });
                  if (jobIndex > -1) {
                    openJobsList[openJobsStatusMap[(action.notification.previousStatusId - 1)]].splice(jobIndex, 1);
                  }
                  if (window.location.pathname.indexOf('job-history') > -1) {
                    jobHistoryList['allJobHistory'].push(jobDetails);
                    jobHistoryList['closedJobs'].push(jobDetails);
                    pageInfo['jobHistoryTotalCount'] = pageInfo['jobHistoryTotalCount'] + 1;
                    pageInfo['closedJobsTotalCount'] = pageInfo['closedJobsTotalCount'] + 1;
                  }
                }
                const allJobHistoryIndex = findIndex(jobHistoryList['allJobHistory'], function (job) {
                  return job.userbookingrequestId == jobDetails.userbookingrequestId;
                });
                const closedJobsIndex = findIndex(jobHistoryList['closedJobs'], function (job) {
                  return job.userbookingrequestId == jobDetails.userbookingrequestId;
                });
                if (allJobHistoryIndex > -1) {
                  jobHistoryList['allJobHistory'][allJobHistoryIndex] = jobDetails;
                }
                if (closedJobsIndex > -1) {
                  jobHistoryList['closedJobs'][closedJobsIndex] = jobDetails;
                }
                break;
              }
              case 'expired':
                {
                  if (action.fromNotification && (action.notificationType === 'Request Expired') && action.notification && action.notification.previousStatusId) {
                    const jobIndex = findIndex(openJobsList[openJobsStatusMap[action.notification.previousStatusId]], function (job) {
                      return job.userbookingrequestId == jobDetails.userbookingrequestId;
                    });
                    if (jobIndex > -1) {
                      openJobsList[openJobsStatusMap].splice(jobIndex, 1);
                    }
                    if (window.location.pathname.indexOf('job-history') > -1) {
                      jobHistoryList['allJobHistory'].push(jobDetails);
                      jobHistoryList['expiredJobs'].push(jobDetails);
                      pageInfo['jobHistoryTotalCount'] = pageInfo['jobHistoryTotalCount'] + 1;
                      pageInfo['expiredJobsTotalCount'] = pageInfo['expiredJobsTotalCount'] + 1;
                    }
                  }
                  const allJobHistoryIndex = findIndex(jobHistoryList['allJobHistory'], function (job) {
                    return job.userbookingrequestId == jobDetails.userbookingrequestId;
                  });
                  const expiredJobsIndex = findIndex(jobHistoryList['expiredJobs'], function (job) {
                    return job.userbookingrequestId == jobDetails.userbookingrequestId;
                  });
                  if (allJobHistoryIndex > -1) {
                    jobHistoryList['allJobHistory'][allJobHistoryIndex] = jobDetails;
                  }
                  if (expiredJobsIndex > -1) {
                    jobHistoryList['expiredJobs'][expiredJobsIndex] = jobDetails;
                  }
                  break;
                }
              default:
                {
                  break;
                }
            }
            // const jobIndex = findIndex(state.openJobsList['waitingJobs'], function(job){return job.id == jobDetails.id});
          }
          jobList[action.jobDetails.id] = jobDetails;
          console.log("jobList = ", jobList);
          return assign({}, state, {
            jobList: jobList,
            isSliderLoaded: true,
            unableToFetchPostedJobById: false,
            openJobsList: openJobsList,
            jobHistoryList: jobHistoryList,
            pageInfo: pageInfo
          });
        }
      }
    case types.GET_JOB_SERVICE_STATUSES:
      {
        return assign({}, state, {
          jobServiceStatuses: action.jobServiceStatuses
        });
      }
    case types.DECLINE_A_JOB:
      {
        let jobList = cloneDeep(state.jobList);
        let currentJob = jobList[action.jobID];
        currentJob.jobStatus = 'Decline';
        currentJob.jobStatusDisplayName = 'Decline';
        jobList[action.jobID] = currentJob;
        return assign({}, state, {
          jobList: jobList
        });
      }

    case types.GET_JOB_HISTORY:
      {
        const newState = {
          currentComponentKey: '',
          nextPageInOpenJobs: action.jobHistoryList && action.currentPage + (action.jobHistoryList.length),
          pageInfo: state.pageInfo
        };
        if (action.unableToFetch) {
          if (action.jobStatusId == 'history') {
            newState['allJobsLoaded'] = true;
            newState['unableToFetchallJobHistory'] = true;
          } else if (action.jobStatusId == 7) {
            newState['completedJobsLoaded'] = true;
            newState['unableToFetchCompletedJobHistory'] = true;
          } else if (action.jobStatusId == 8) {
            newState['expiredJobsLoaded'] = true;
            newState['unableToFetchexpiredJobHistory'] = true;
          } else if (action.jobStatusId == 5) {
            newState['declinedJobsLoaded'] = true;
            newState['unableToFetchdeclinedJobHistory'] = true;
          } else if (action.jobStatusId == 'closed') {
            newState['closedJobsLoaded'] = true;
            newState['unableToFetchclosedJobHistory'] = true;
          }
        } else {
          let jobHistoryList = {};
          let a = cloneDeep(action.jobHistoryList);
          a = normalizeJobHistoryData(a);
          if (action.jobStatusId == 7) {
            let b = cloneDeep(state.jobHistoryList.completedJobs);
            jobHistoryList = {
              ...state.jobHistoryList,
              completedJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              completedJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['completedJobsLoaded'] = true;
          } else if (action.jobStatusId == 8) {
            let b = cloneDeep(state.jobHistoryList.expiredJobs);
            jobHistoryList = {
              ...state.jobHistoryList,
              expiredJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              expiredJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['expiredJobsLoaded'] = true;
          } else if (action.jobStatusId == 5) {
            let b = cloneDeep(state.jobHistoryList.declinedJobs);
            jobHistoryList = {
              ...state.jobHistoryList,
              declinedJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              declinedJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['declinedJobsLoaded'] = true;
          } else if (action.jobStatusId == 'history') {
            let b = cloneDeep(state.jobHistoryList.allJobHistory);
            jobHistoryList = {
              ...state.jobHistoryList,
              allJobHistory: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              jobHistoryTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['allJobsLoaded'] = true;
          } else if (action.jobStatusId == 'closed') {
            let b = cloneDeep(state.jobHistoryList.closedJobs);
            jobHistoryList = {
              ...state.jobHistoryList,
              closedJobs: action.fromLoadMore ? concat(b, a) : a
            };
            newState['pageInfo'] = {
              ...state.pageInfo,
              closedJobsTotalCount: action.pageInfo && action.pageInfo.rowCount ? action.pageInfo.rowCount : 0,
            };
            newState['closedJobsLoaded'] = true;
          }
          newState['jobHistoryList'] = jobHistoryList;
          newState['isJobHistoryLoaded'] = true;
        }

        return assign({}, state, newState);
      }
    // case types.SEND_QUOTE: {
    //   return assign({}, state);
    // }
    case types.UPDATE_JOB_QUOTE_NOTE:
      {
        let jobList = cloneDeep(state.jobList);
        let currentJob = jobList[action.jobID];
        if (action.jobData) {
          currentJob.garagejobnote = action.jobData.garagejobnote;
          jobList[action.jobID] = currentJob;
          return assign({}, state, {
              jobList: jobList
          });
        }
        else {
          return assign({}, state, {
              jobList: jobList
          });
        }
      }
    case types.UPDATE_JOB_STATUS:
      {
        let jobList = cloneDeep(state.jobList);
        let currentJob = jobList[action.jobID];
        if (action.updatedQuotesList && action.updatedQuotesList.length) {
          currentJob.quotesList = action.updatedQuotesList;
          if (currentJob.garagejobquote && currentJob.garagejobquote.garagejobquotesdetail && currentJob.garagejobquote.garagejobquotesdetail.length) {
            currentJob.garagejobquote.garagejobquotesdetail = action.updatedQuotesList;
          }
        }

        currentJob.jobStatus = action.nextJobStatus;
        currentJob.jobStatusDisplayName = action.nextJobStatus;
        jobList[action.jobID] = currentJob;
        if (action.nextJobStatus == 'decline') {
          let openJobsList = cloneDeep(state.openJobsList);
          let pageInfo = cloneDeep(state.pageInfo);
          let jobIndex = '';
          // let job = '';
          if (action.currentJobStatus === "waiting") {
            jobIndex = findIndex(openJobsList['waitingJobs'], function (job) {
              return job.userbookingrequestId == action.jobID;
            });
            openJobsList['waitingJobs'].splice(jobIndex, 1);
            pageInfo.waitingJobsTotalCount = pageInfo.waitingJobsTotalCount ? (pageInfo.waitingJobsTotalCount - 1) : 0;
            // job = openJobsList['waitingJobs'][jobIndex];
          } else if (action.currentJobStatus == 'applied') {
            jobIndex = findIndex(openJobsList['appliedJobs'], function (job) {
              return job.userbookingrequestId == action.jobID;
            });
            openJobsList['appliedJobs'].splice(jobIndex, 1);
            pageInfo.appliedJobsTotalCount = pageInfo.appliedJobsTotalCount ? (pageInfo.appliedJobsTotalCount - 1) : 0;
            // job = openJobsList['appliedJobs'][jobIndex];
          } else if (action.currentJobStatus == 'confirmed') {
            jobIndex = findIndex(openJobsList['confirmedJobs'], function (job) {
              return job.userbookingrequestId == action.jobID;
            });
            openJobsList['confirmedJobs'].splice(jobIndex, 1);
            pageInfo.confirmedJobsTotalCount = pageInfo.confirmedJobsTotalCount ? (pageInfo.confirmedJobsTotalCount - 1) : 0;
            // job = openJobsList['confirmedJobs'][jobIndex];
          }
          return assign({}, state, {
            openJobsList: openJobsList,
            pageInfo: pageInfo
          });
        } else if (action.nextJobStatus == 'Completed') {
          let openJobsList = cloneDeep(state.openJobsList);
          let jobHistory = cloneDeep(state.jobHistory);
          let pageInfo = cloneDeep(state.pageInfo);
          let jobIndex = '';
          if (action.currentJobStatus === "confirmed") {
            jobIndex = findIndex(openJobsList['confirmedJobs'], function (job) {
              return job.userbookingrequestId == action.jobID;
            });
          } else {
            jobIndex = findIndex(openJobsList['inProgressJobs'], function (job) {
              return job.userbookingrequestId == action.jobID;
            });
          }
          if (jobIndex > -1) {
            const job = action.currentJobStatus === "confirmed" ? openJobsList['confirmedJobs'][jobIndex] : openJobsList['inProgressJobs'][jobIndex];
            const jobData = {
              'jobdetailstatusId': job.jobdetailstatusId,
              'createdAt': job.createdAt,
              'jobEndDatetime': job.jobEndDatetime,
              'jobStartDatetime': job.jobStartDatetime,
              'userbookingrequestId': job.userbookingrequestId,
              'jobStatus': action.nextJobStatus ? action.nextJobStatus.toLocaleLowerCase() : job.jobdetailstatus.name,
              'jobStatusDisplayName': action.nextJobStatus ? action.nextJobStatus : '-',
              'totalamount': (job.garagejobquotesdetail && job.garagejobquotesdetail.length) ? sumBy(job.garagejobquotesdetail, function (quote) {
                return quote.amount;
              }) : '-',
              'currency': (job.garagejobquotesdetail && job.garagejobquotesdetail.length) ? job.garagejobquotesdetail[0].currency : '-',
              'carmake': (job.userbookingrequest && job.userbookingrequest.vehicles && job.userbookingrequest.vehicles.carmake) ? job.userbookingrequest.vehicles.carmake : '-',
              'carmodel': (job.userbookingrequest && job.userbookingrequest.vehicles && job.userbookingrequest.vehicles.carmodel) ? job.userbookingrequest.vehicles.carmodel : '-',
              'area': (job.userbookingrequest && job.userbookingrequest.location) ? job.userbookingrequest.location : '-',
              'details': (job.garagejobquotesdetail && job.garagejobquotesdetail.length) ? (job.garagejobquotesdetail.length > 1 ? (job.garagejobquotesdetail[0].garagejobquotesdetail_services.name + ', +' + (job.garagejobquotesdetail.length - 1) + ' more') : job.garagejobquotesdetail[0].garagejobquotesdetail_services.name) : '-',
              'serviceType': (job.userbookingrequest && job.userbookingrequest.services && job.userbookingrequest.services.name) ? job.userbookingrequest.services.name : '-',
              'paymentStatus':job.paymentstatus?job.paymentstatus:"",
              'requestId':(job.userbookingrequest && job.userbookingrequest.requestid) ? job.userbookingrequest.requestid : '-',
            };
            if (action.currentJobStatus === "confirmed") {
              openJobsList['confirmedJobs'].splice(jobIndex, 1);
              pageInfo.confirmedJobsTotalCount = pageInfo.confirmedJobsTotalCount - 1;
            } else {
              openJobsList['inProgressJobs'].splice(jobIndex, 1);
              pageInfo.inProgressJobsTotalCount = pageInfo.inProgressJobsTotalCount - 1;
            }
            jobHistory.unshift(jobData);
          }
          return assign({}, state, {
            jobList: jobList,
            openJobsList: openJobsList,
            jobHistory: jobHistory,
            pageInfo: pageInfo
          });
        } else if (action.currentJobStatus == 'confirmed') {
          let openJobsList = cloneDeep(state.openJobsList);
          let pageInfo = cloneDeep(state.pageInfo);
          const jobIndex = findIndex(openJobsList['confirmedJobs'], function (job) {
            return job.userbookingrequestId == action.jobID;
          });
          if (jobIndex > -1) {
            const job = openJobsList['confirmedJobs'][jobIndex];
            openJobsList['confirmedJobs'].splice(jobIndex, 1);
            openJobsList['inProgressJobs'].unshift(job);
            pageInfo.confirmedJobsTotalCount = pageInfo.confirmedJobsTotalCount + 1;
            pageInfo.inProgressJobsTotalCount = pageInfo.inProgressJobsTotalCount - 1;
          }
          return assign({}, state, {
            jobList: jobList,
            openJobsList: openJobsList,
            pageInfo: pageInfo
          });
        } else if (action.currentJobStatus == 'applied') {
          let openJobsList = cloneDeep(state.openJobsList);
          let pageInfo = cloneDeep(state.pageInfo);
          const jobIndex = findIndex(openJobsList['appliedJobs'], function (job) {
            return job.userbookingrequestId == action.jobID;
          });
          if (jobIndex > -1) {
            const job = openJobsList['appliedJobs'][jobIndex];
            openJobsList['appliedJobs'].splice(jobIndex, 1);
            openJobsList['confirmedJobs'].unshift(job);
            pageInfo.appliedJobsTotalCount = pageInfo.appliedJobsTotalCount ? (pageInfo.appliedJobsTotalCount - 1) : 0;
            pageInfo.confirmedJobsTotalCount = pageInfo.confirmedJobsTotalCount + 1;
          }
          return assign({}, state, {
            jobList: jobList,
            openJobsList: openJobsList,
            pageInfo: pageInfo
          });
        } else {
          return assign({}, state, {
            jobList: jobList
          });
        }
      }
    case types.CAR_MAKE_AND_MODELS: {
      if (action.unableToFetch) {
        let carMakeAndModels = cloneDeep(state.carMakeAndModels);
        if (action.responseType == 'model') {
          let index = findIndex(carMakeAndModels, { id: action.makeId });
          if (index != -1 && carMakeAndModels && carMakeAndModels.length && carMakeAndModels[index]) {
            carMakeAndModels[index].isCarModelLoaded = true;
          }
        }
        return assign({}, state, { carMakeAndModels: carMakeAndModels, currentComponentKey: '' });
      } else {
        let carMakeAndModels = cloneDeep(state.carMakeAndModels);
        if (action.responseType == 'make') {
          let manufacturers = [];
          map(action.manufacturers, (make) => {
            let index = findIndex(carMakeAndModels, { id: make.id });
            if (make) {
              manufacturers.push({
                "carmodel": index != -1 ? carMakeAndModels[index] && carMakeAndModels[index].carmodel : [],
                "isCarModelLoaded": carMakeAndModels && carMakeAndModels.length && carMakeAndModels[index] && carMakeAndModels[index].carmodel && carMakeAndModels[index].carmodel.length ? true : false,
                "id": make.id,
                "lang": '',
                "name": make.name,
                "photos": make.photos
              });
            }
          });
          carMakeAndModels = manufacturers;
        } else if (action.responseType == 'model') {
          let index = findIndex(carMakeAndModels, { id: action.makeId });
          if (index != -1 && carMakeAndModels && carMakeAndModels.length && carMakeAndModels[index]) {
            carMakeAndModels[index].carmodel = action.models;
            carMakeAndModels[index].isCarModelLoaded = true;
          }
        }
        return assign({}, state, { carMakeAndModels: carMakeAndModels, currentComponentKey: '' });
      }
    }
    case types.UPDATE_NEW_COUNT_FOR_JOB_ID: {
      const jobList = cloneDeep(state.jobList);
      if (jobList[action.jobId]) {
        jobList[action.jobId].alreadySeen = true;
      }
      return assign({}, state, {
        jobList: jobList
      });
    }
    case types.OPEN_JOBS_FILTER: {
      let openJobsFilters = cloneDeep(state.openJobsFilters);
      if (action.isSort) {
        if (action.openJobType == 'confirmed') {
          openJobsFilters.confirmed.sort = action.filterState;
        } else if (action.openJobType == 'waiting') {
          openJobsFilters.waiting.sort = action.filterState;
        } else if (action.openJobType == 'applied') {
          openJobsFilters.applied.sort = action.filterState;
        } else if (action.openJobType == 'inprogress') {
          openJobsFilters.inprogress.sort = action.filterState;
        } else if (action.openJobType == 'jobhistory') {
          openJobsFilters.jobhistory.sort = action.filterState;
        }else if (action.openJobType == 'completed') {
          openJobsFilters.jobhistory.sort = action.filterState;
        }
      } else {
        if (action.openJobType == 'confirmed') {
          openJobsFilters.confirmed.filter = action.filterState;
        } else if (action.openJobType == 'waiting') {
          openJobsFilters.waiting.filter = action.filterState;
        } else if (action.openJobType == 'applied') {
          openJobsFilters.applied.filter = action.filterState;
        } else if (action.openJobType == 'inprogress') {
          openJobsFilters.inprogress.filter = action.filterState;
        } else if (action.openJobType == 'jobhistory') {
          openJobsFilters.jobhistory.filter = action.filterState;
        } else if (action.openJobType == 'completed') {
          openJobsFilters.jobhistory.filter = action.filterState;
        }
      }
      return assign({}, state, {
        openJobsFilters: openJobsFilters
      });
    }
    case types.SET_SERVICED_KMS: {
      const jobList = cloneDeep(state.jobList);
      const selectedJob = jobList[action.requestId];
      if (selectedJob && selectedJob.garagejobquote) {
        selectedJob.garagejobquote.servicedAtKms = action.kms;
      }
      return {jobList: jobList};
    }
    default:
      return state;
  }
}

function normalizeJobHistoryData(newJobHistoryData) {
  let jobHistory = [];
  each(newJobHistoryData, (job) => {


    const jobData = {
      'jobdetailstatusId': job.jobdetailstatusId,
      'createdAt': job.createdAt,
      'jobEndDatetime': job.jobEndDatetime,
      'jobStartDatetime': job.jobStartDatetime,
      'userbookingrequestId': job.userbookingrequestId,
      'jobStatus': job.jobdetailstatus.name,
  /*    'totalamount': (job.garagejobquotesdetail && job.garagejobquotesdetail.length) ? sumBy(job.garagejobquotesdetail, function (quote) {
        return quote.amount;
      }) : '-',*/
      'totalamount': job.totalamount,
      'discountAmount': job.discountAmount,
      'currency': (job.garagejobquotesdetail && job.garagejobquotesdetail.length) ? job.garagejobquotesdetail[0].currency : '-',
      'carmake': (job.userbookingrequest && job.userbookingrequest.vehicles && job.userbookingrequest.vehicles.carmake) ? job.userbookingrequest.vehicles.carmake : '-',
      'carmodel': (job.userbookingrequest && job.userbookingrequest.vehicles && job.userbookingrequest.vehicles.carmodel) ? job.userbookingrequest.vehicles.carmodel : '-',
      'area': (job.userbookingrequest && job.userbookingrequest.location) ? job.userbookingrequest.location : '-',
      'details': (job.garagejobquotesdetail && job.garagejobquotesdetail.length) ? (job.garagejobquotesdetail.length > 1 ? (job.garagejobquotesdetail[0].garagejobquotesdetail_services.name + ', +' + (job.garagejobquotesdetail.length - 1) + ' more') : job.garagejobquotesdetail[0].garagejobquotesdetail_services.name) : '-',
      'serviceType': (job.userbookingrequest && job.userbookingrequest.services && job.userbookingrequest.services.name) ? job.userbookingrequest.services.name : '-',
      'paymentStatus':job.paymentstatus?job.paymentstatus:"",
      'requestId':(job.userbookingrequest && job.userbookingrequest.requestid) ? job.userbookingrequest.requestid : '-',
    };
    jobHistory.push(jobData);
  });
  return jobHistory && jobHistory.length ? jobHistory : [];
}



// WEBPACK FOOTER //
// ./src/reducers/jobRequestReducer.js